import { useEffect, useState, useMemo, useCallback } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { useTranslation } from "next-i18next";
import moment from 'moment';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import StepConnector from '@material-ui/core/StepConnector';
import clsx from 'clsx';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    comment_master,
    create_order_saga,
    card_select,
    master_data_act,
    master_data_saga,
    add_go_home_price,
    master_add_data,
    master_address_select,
    send_order_code_saga
} from "../store/actions/master";
import { get_room_for_client } from "../store/actions/chat";
import { master_card_saga } from "../store/actions/card";
import getPosition from "../utils/getDistance";
import { getServiceByAddress } from '../store/sagas/serviceSaga';
import { get_services_by_address_saga } from '../store/actions/service';

const error_notify = () => toast.error("Пожалуйста, попробуйте снова", {
    position: toast.POSITION.TOP_CENTER
});
const MasterPage = (props) => {
    var date_now = new Date();
    var m = date_now.getMonth() + 1;
    var y = date_now.getFullYear();
    const [activeInput, setActive] = useState(false);
    const [activePage, setActivePage] = useState("gallery");
    const [location, setLocation] = useState("");
    const [activeStep, setActiveStep] = useState(1);
    const [submitted, setSubmitted] = useState(false);
    const [codeModal, setCodeModal] = useState(false);
    const [code, setCode] = useState(false);
    const [selectedService, setSelectedService] = useState(null);
    const master_data = useSelector(state => state.master_data);
    const review = useSelector(state => state.review);
    const schedule = useSelector(state => state.master_schedule);
    const settings = useSelector(state => state.settings);
    const card_list = useSelector(state => state.card_list);
    const translate = useSelector(state => state.translate);
    const user = useSelector(state => state.getme.data);
    const master_schedule = useSelector(state => state.master_schedule);

    const router = useRouter();
    const dispatch = useDispatch();
    const comment = (data) => dispatch(comment_master(data));
    const add_go_home_price_func = (id) => dispatch(add_go_home_price(id));
    const get_card = () => dispatch(master_card_saga({ token: props.token }));
    const select_card = (item) => {
        dispatch(card_select(item));
    };
    const handleCloseCodeModal = useCallback(() => {
        setCodeModal(false);
    }, []);
    const handleChangeCode = useCallback((value) => {
        setCode(value);
    }, []);
    const handleOpenCodeModal = useCallback(() => {
        setCodeModal(true);
    }, []);
    const send_code = () => dispatch(send_order_code_saga({ phone_number: master_data?.phone_number?.value, cb: handleOpenCodeModal }));
    const add_more_info = (data) => dispatch(master_add_data(data));
    const delete_master_data = () => dispatch(master_data_act());
    const get_master_data = () => dispatch(master_data_saga({ token: props.token, id: props.id }));
    const get_room = () => {
        dispatch(get_room_for_client({
            token: props.token,
            data: { user_id: props.id, is_with_admin: false },
            cb: () => handleClick(`/chats?master=${master_data.data.id}`)
        }));
    };
    const service_data = useMemo(() => {
        const array = master_data.data.master_services ? master_data.data.master_services : [];
        for (let index = 0; index < array.length; index++) {
            const element = array[index];
            if (master_schedule.selected_service && element?.id === master_schedule.selected_service) {
                return array[index];
            }
            // else if (element?.id === +props.service) {
            //     return array[index];
            // }

        }
    }, [master_data.data.master_services, master_schedule.selected_service]);
    const { t } = useTranslation();
    // const [go_home, setGoHome] = useState(false);
    const handleClick = (href) => {
        router.push(href);
    };
    var rad = function (x) {
        return x * Math.PI / 180;
    };
    const find_go_home_price = () => {
        const array = master_data.data.master_services ? master_data.data.master_services : [];
        for (let index = 0; index < array.length; index++) {
            const element = array[index];
            if (element.go_home) {
                return element.go_home_price;
            }
        }
    };
    var getDistance = function (p1, p2) {
        if (p1.lat && p2.lng && p1.lng && p2.lat) {
            var R = 6378137; // Earth’s mean radius in meter
            var dLat = rad(p2.lat - p1.lat);
            var dLong = rad(p2.lng - p1.lng);
            var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) *
                Math.sin(dLong / 2) * Math.sin(dLong / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            var d = R * c;
            var value = Math.floor(d / 1000);
            setLocation(value);
            return value; // returns the distance in meter
        }
    };
    const category = () => {
        const array = master_data.data.master_services ? master_data.data.master_services : [];
        let list = [];
        let same = false;
        for (let index = 0; index < array.length; index++) {
            const element = array[index]?.service_details;
            if (index === 0) {
                list.push({
                    // category: element.category,
                    ...element?.sub_category
                });
            } else {
                for (let ind = 0; ind < list.length; ind++) {
                    const el = list[ind];
                    if (el.id === element?.sub_category?.id) {
                        same = true;
                        break;
                    } else {
                        same = false;
                    }
                }
                if (!same) {
                    list.push({
                        // category: element.sub_category,
                        ...element?.sub_category
                    });
                }
            }
        }
        return list;
    };

    const user_info = master_data?.first_name ? {
        first_name: master_data?.first_name?.value,
        last_name: master_data?.last_name?.value,
        email: master_data?.email?.value,
        phone_number: master_data?.phone_number?.value,
        code: master_data?.code?.value?.replaceAll(' ', ''),
    } : {}
    let amount_data = user && user.id ? {
        "day": `${moment.utc(master_schedule.selected_schedule?.start_time, 'YYYY-MM-DDTHH:mm:ssZ').format("YYYY-MM-DD")}`,
        "start_time": master_schedule.selected_schedule
            ? `${moment.utc(master_schedule.selected_schedule?.start_time, 'YYYY-MM-DDTHH:mm:ssZ').format("HH:mm:ss")}`
            : (props.schedule ? `${moment.utc(props.schedule?.start_time, 'YYYY-MM-DDTHH:mm:ssZ').format("HH:mm:ss")}` : ''),
        "end_time": master_schedule.selected_schedule
            ? `${moment.utc(master_schedule.selected_schedule?.end_time, 'YYYY-MM-DDTHH:mm:ssZ').format("HH:mm:ss")}`
            : (props.schedule ? `${moment.utc(props.schedule?.end_time, 'YYYY-MM-DDTHH:mm:ssZ').format("HH:mm:ss")}` : ''),
        // "calendar_id": master_data.data.google_calendar_id,
        "user_id": user ? user.id : null,
        "master_id": +props.id,
        "comment": master_data.comment ? master_data?.comment : "",
        "service_id": service_data ? service_data?.service_details?.id : selectedService?.service_details?.id,
        "minutes": service_data ? service_data?.minutes : selectedService?.minutes,
        "price": service_data ? service_data?.price : selectedService?.price,
        "save_new_card": false,
        // "existing_card": schedule.selected_card ? schedule.selected_card.id : null,
        "token": props?.token,
        "go_home": service_data ? service_data?.go_home : selectedService?.go_home,
        "address_id": master_schedule.selected_address ? +master_schedule?.selected_address : master_data.data?.master_work_address ? master_data.data?.master_work_address[0]?.work_address.id : null,
        ...user_info
    } : {
        "day": `${moment.utc(master_schedule.selected_schedule?.start_time, 'YYYY-MM-DDTHH:mm:ssZ').format("YYYY-MM-DD")}`,
        "start_time": master_schedule.selected_schedule
            ? `${moment.utc(master_schedule.selected_schedule?.start_time, 'YYYY-MM-DDTHH:mm:ssZ').format("HH:mm:ss")}`
            : (props.schedule ? `${moment.utc(props.schedule?.start_time, 'YYYY-MM-DDTHH:mm:ssZ').format("HH:mm:ss")}` : ''),
        "end_time": master_schedule.selected_schedule
            ? `${moment.utc(master_schedule.selected_schedule?.end_time, 'YYYY-MM-DDTHH:mm:ssZ').format("HH:mm:ss")}`
            : (props.schedule ? `${moment.utc(props.schedule?.end_time, 'YYYY-MM-DDTHH:mm:ssZ').format("HH:mm:ss")}` : ''),
        // "calendar_id": master_data.data.google_calendar_id,
        "master_id": +props.id,
        "comment": master_data.comment ? master_data?.comment : "",
        "service_id": service_data ? service_data?.service_details?.id : selectedService?.service_details?.id,
        "minutes": service_data ? service_data?.minutes : selectedService?.minutes,
        "price": service_data ? service_data?.price : selectedService?.price,
        "save_new_card": false,
        // "existing_card": schedule.selected_card ? schedule.selected_card.id : null,
        "go_home": service_data ? service_data?.go_home : selectedService?.go_home,
        "address_id": master_schedule.selected_address ? +master_schedule?.selected_address : master_data.data?.master_work_address ? master_data.data?.master_work_address[0]?.work_address.id : null,
        ...user_info
    };
    const create_order = () => {
        // if (!props.schedule && !props.amount) {
        //     handleClick(`/master/${props.id}/register-master`)
        //     error_notify()
        //     // пожалуйста, попробуйте снова
        // } else {
        const existing_card = schedule?.selected_card?.id ? { existing_card: schedule?.selected_card?.id } : {}
        let location = (((service_data && service_data?.go_home) || (selectedService && selectedService?.go_home)) && master_data?.location)
            ? { location: master_data?.location?.value }
            : {};

        const card_data = master_data?.number ? {
            number: master_data?.number?.value,
            exp_month: master_data?.exp_month?.value,
            exp_year: master_data?.exp_year?.value,
            cvc: master_data?.cvc?.value,
        } : {}
        let data = props.amount
            ? {
                translate,
                openTab: (url) => router.push(url),
                cb: () => {
                    dispatch(master_address_select({ selected_service: service_data ? service_data?.id : selectedService?.id }));
                    document.cookie = `prepay=; path=/`
                    return handleClick(`/master/${props.id}/register-master/registation-end`);
                },
                ...props.amount,
                ...existing_card,
                ...card_data
            }
            : {
                translate,
                openTab: (url) => router.push(url),
                cb: () => {
                    dispatch(master_address_select({ selected_service: service_data ? service_data?.id : selectedService?.id }));
                    document.cookie = `prepay=; path=/`
                    return handleClick(`/master/${props.id}/register-master/registation-end`);
                },
                ...amount_data,
                ...existing_card,
                ...card_data
            };
        dispatch(create_order_saga(props.token
            ? data
            : {
                ...data,
                ...location
            }));
    };
    const keyPress = (e) => {
        if (e.key === "Enter") {
            create_order();
        };
    };
    // }
    useEffect(() => {
        if (!props.lat) {
            // getPosition();
        }
        get_master_data();
        getDistance(
            { lat: props.lat, lng: props.lng },
            { lat: master_data.data.address_latitude, lng: master_data.data.address_longitude });
        get_card();
       
    }, [props.loggedIn]);
    useEffect(() => {
        if (master_schedule.selected_service) {
            setSelectedService(service_data);
        }

    }, [master_data.data.master_services, master_schedule.selected_service]);
    const getServicesByAddress = async () => {
        await dispatch(get_services_by_address_saga({ "master": master_data?.data?.id, "address": props?.address }));
    };
    useEffect(() => {
        if (master_data.data.id && master_data.data.master_services.length === 0) {
            getServicesByAddress();
        }
    }, []);
    useEffect(() => {
        return () => delete_master_data();
    }, []);
    // STYLE
    const useStyles = makeStyles((theme) => ({
        root: {
            backgroundColor: "#FEFCFA"
        },
        button: {
            marginRight: theme.spacing(1),
        },
        instructions: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
    }));
    const classes = useStyles();
    const handleNext = () => {
        setActiveStep((prevActiveStep) => {
            // if (prevActiveStep === 1 && !service_data?.service_details?.id && !master_schedule.selected_address) {
            //     toast.error(`${t('serviceSelectionLabel')}`);
            //     return prevActiveStep;
            // }
            if ((schedule.selected_schedule && !schedule.selected_schedule.start_time && prevActiveStep === 1) ||
                (!service_data && prevActiveStep === 0)) {
                return prevActiveStep;
            }
            else {
                return prevActiveStep + 1;
            }
        });
        // if (activeStep === 2) {
        //     create_order()
        // }
    };
    // const backdrop_ref = useRef(null);
    // const lastOpenState_ref = useRef(false);
    // if (lastOpenState_ref.current === true && activeStep === 2) {
    //     backdrop_ref.current.removeEventListener('touchmove', handleNext);
    // }
    // lastOpenState_ref.current = activeStep;

    function getSteps() {
        return [t("stepLabel"), t("stepLabel"), t("stepLabel")];
    }
    const ColorlibConnector = withStyles({
        alternativeLabel: {
            top: 22,
        },
        active: {
            '& $line': {
                backgroundImage:
                    'linear-gradient(90deg, #F9989C 0%, #FBB0B5 96.37%)',
            },
        },
        completed: {
            '& $line': {
                backgroundImage:
                    'linear-gradient(90deg, #F9989C 0%, #FBB0B5 96.37%)',
            },
        },
        line: {
            height: 20,
            width: 20,
            border: 0,
            backgroundColor: '#eaeaf0',
            borderRadius: "50%",
            margin: "auto"
        },
    })(StepConnector);

    const useColorlibStepIconStyles = makeStyles({
        root: {
            backgroundColor: '#FFFFFF',
            zIndex: 1,
            color: '#464646',
            display: 'flex',
            borderRadius: '50%',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0px 5px 14px rgba(0, 0, 0, 0.1)',
        },
        active: {
            backgroundImage:
                'linear-gradient(90deg, #F9989C 0%, #FBB0B5 96.37%)',
            boxShadow: '0px 5px 14px rgba(0, 0, 0, 0.1)',
            color: '#FFFFFF',
            width: "100%",
            height: "100%"
        },
        completed: {
            backgroundImage:
                'linear-gradient(90deg, #F9989C 0%, #FBB0B5 96.37%)',
            color: '#FFFFFF',
            width: "100%",
            height: "100%"
        },
    });

    function ColorlibStepIcon(props) {
        const classes = useColorlibStepIconStyles();
        const { active, completed } = props;

        const icons = {
            1: <span>1</span>,
            2: <span>2</span>,
            3: <span>3</span>,
        };
        return (
            <div
                className={clsx(classes.root, {
                    [classes.active]: active,
                    [classes.completed]: completed,
                })}
            >
                {icons[String(props.icon)]}
            </div>
        );
    }

    ColorlibStepIcon.propTypes = {
        /**
         * Whether this step is active.
         */
        active: PropTypes.bool,
        /**
         * Mark the step as completed. Is passed to child components.
         */
        completed: PropTypes.bool,
        /**
         * The label displayed in the step icon.
         */
        icon: PropTypes.node,
    };
    return {
        master_data,
        review,
        activePage,
        card_list,
        user,
        schedule,
        activeStep,
        ColorlibStepIcon,
        classes,
        location,
        settings,
        translate,
        amount_data,
        m,
        y,
        submitted,
        selectedService,
        service_data,
        codeModal,
        code,
        activeInput,
        keyPress,
        setActive,
        send_code,
        add_more_info,
        handleOpenCodeModal,
        handleCloseCodeModal,
        handleChangeCode,
        setSubmitted,
        setActivePage,
        handleClick,
        category,
        comment,
        create_order,
        select_card,
        handleNext,
        getSteps,
        add_go_home_price_func,
        find_go_home_price,
        get_room,
        router,
        useStyles,
        ColorlibConnector,
        // backdrop_ref
        // getStepContent
    };
};
export default MasterPage;